export default "__VITE_ASSET__8484d266__"